/**
 * Filter selectors for the adjustment reasons catalog list.
 * Empty option value means "Todos" and triggers multi-request fan-out upstream.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardBody, Col, Form, FormGroup, Input, Row } from 'reactstrap';

import {
  countryOptions,
  roleScopeOptions,
  scopeOptions,
  typeOptions,
} from '../constants';

const FiltersCard = ({ filters, onFilterChange }) => (
  <Card className="mb-4">
    <CardBody>
      <h4 className="mb-3">Filtros</h4>
      <Form>
        <Row>
          <Col md="3">
            <FormGroup>
              <label className="form-control-label">Pais</label>
              <Input
                type="select"
                value={filters.country}
                onChange={(event) => onFilterChange('country', event.target.value)}
              >
                <option value="">Todos</option>
                {countryOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </Input>
            </FormGroup>
          </Col>
          <Col md="3">
            <FormGroup>
              <label className="form-control-label">Scope</label>
              <Input
                type="select"
                value={filters.scope}
                onChange={(event) => onFilterChange('scope', event.target.value)}
              >
                <option value="">Todos</option>
                {scopeOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </Input>
            </FormGroup>
          </Col>
          <Col md="3">
            <FormGroup>
              <label className="form-control-label">Tipo</label>
              <Input
                type="select"
                value={filters.type}
                onChange={(event) => onFilterChange('type', event.target.value)}
              >
                <option value="">Todos</option>
                {typeOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </Input>
            </FormGroup>
          </Col>
          <Col md="3">
            <FormGroup>
              <label className="form-control-label">Rol</label>
              <Input
                type="select"
                value={filters.role_scope}
                onChange={(event) => onFilterChange('role_scope', event.target.value)}
              >
                <option value="">Todos</option>
                {roleScopeOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </Input>
            </FormGroup>
          </Col>
        </Row>
      </Form>
    </CardBody>
  </Card>
);

FiltersCard.propTypes = {
  filters: PropTypes.shape({
    country: PropTypes.string,
    scope: PropTypes.string,
    type: PropTypes.string,
    role_scope: PropTypes.string,
  }).isRequired,
  onFilterChange: PropTypes.func.isRequired,
};

export default FiltersCard;
